export enum FloorPlans {
  any = 'any',
  studio = 'studio',
  oneBed = 'oneBed',
  twoBed = 'twoBed',
  threeBed = 'threeBed',
  fourBed = 'fourBed',
  fiveBed = 'fiveBed',
}
